export default __webpack_public_path__ + "static/media/logout.7d1726c4.svg";